<template>
    <section>
      <h1>人脸识别</h1>
      <video id="video" width="320" height="240" preload autoplay loop muted></video>
      <canvas id="canvas" width="320" height="240"></canvas>
    </section>
</template>

<script>
  import 'tracking/build/tracking-min'
  import 'tracking/build/data/face-min'
    export default {
        name: "CheckDisclose",
        methods:{
          initCamera:function(){
            let video = document.getElementById('video');
            let canvas = document.getElementById('canvas');
            let context = canvas.getContext('2d');

            let tracker = new tracking.ObjectTracker('face');
            tracker.setInitialScale(4);
            tracker.setStepSize(2);
            tracker.setEdgesDensity(0.1);

            tracking.track('#video', tracker, { camera: true });

            tracker.on('track', function(event) {
              context.clearRect(0, 0, canvas.width, canvas.height);

              event.data.forEach(function(rect) {
                console.log(rect)
                context.strokeStyle = '#a64ceb';
                context.strokeRect(rect.x, rect.y, rect.width, rect.height);
                context.font = '11px Helvetica';
                context.fillStyle = "#fff";
                context.fillText('x: ' + rect.x + 'px', rect.x + rect.width + 5, rect.y + 11);
                context.fillText('y: ' + rect.y + 'px', rect.x + rect.width + 5, rect.y + 22);
              });
            });
          }
        },
        mounted() {
            this.initCamera();
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/qrcodeview/CheckDisclose.vue